import { ConfigData } from 'types/interfaces';

const config: ConfigData = {
  ID: 'EMPLOYMENT_V2_STEP',
  STEP_JOINT_ID: 'EMPLOYMENT_V2_STEP_JOINT',
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  FOOTER: true,
  PROGRESS_BAR_COUNT: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};

export default config;
